import React from "react";
import { Box, Typography } from "@mui/material";

const TimeAxis = () => {
    const labels = [
        "12 AM", "2 AM", "4 AM", "6 AM", "8 AM", "10 AM",
        "12 PM", "2 PM", "4 PM", "6 PM", "8 PM", "10 PM", "12 AM"
    ];

    return (
        <Box sx={{ position: "relative", width: "100%" }}>
            <Box
                sx={{
                    height: "1px",
                    backgroundColor: "#E9EFF5",
                    width: "100%",
                    position: "absolute",
                    bottom: "20px", // position above labels
                    left: '0',
                }}
            />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    position: "relative",
                    width: "calc(100% + 30px)",
                    left: '-15px'
                }}
            >
                {labels.map((label, index) => (
                    <Typography
                        key={index}
                        variant="body2"
                        sx={{ color: "#7c8b9a", fontSize: '12px', fontWeight: 500 }}
                    >
                        {label}
                    </Typography>
                ))}
            </Box>
        </Box>
    );
};

export default TimeAxis;
